var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFold1Decoration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 393,
    viewBox: "0 0 382 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.99999 39.0467C233.573 -93.7937 305.002 163.883 305.002 163.883C305.002 163.883 322.602 217.618 367.086 275.578C411.569 333.539 347.397 376.511 203.155 378.99C58.9132 381.468 86.4276 410.414 52.3085 372.991C18.1894 335.567 0.99999 223.301 0.99999 223.301",
    stroke: "#CDD6FF",
    strokeWidth: 2,
    strokeDasharray: "10 10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 222,
    r: 6,
    fill: "#A7B7FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold1Decoration);
export default __webpack_public_path__ + "static/media/fold-1-decoration.ea19592729fbff0839a836b74a3fb63c.svg";
export { ForwardRef as ReactComponent };